// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', sans-serif;
  background-color: #0F0F1B;
  color: #E4E4E7;
  line-height: 1.6;
}

/* Headings */
h1, h2, h3 {
  font-weight: 700;
  color: #ffffff;
}

/* Links */
a {
  color: inherit;
  text-decoration: none;
}

/* Buttons */
button {
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
}

button.primary {
  background-color: #FC2783;
  color: white;
  padding: 10px 16px;
  font-weight: 600;
  border: none;
}

button.primary:hover {
  background-color: #ff4598;
  box-shadow: 0 0 6px rgba(252, 39, 131, 0.5);
}

/* Forms */
input, textarea, select {
  font-family: inherit;
  font-size: 1rem;
  background-color: #2A2A40;
  color: #fff;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 10px;
}

input::placeholder {
  color: #888;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: #1C1C2E;
  color: #fff;
  border-bottom: 1px solid #2A2A40;
}

.header .logo {
  font-size: 1.5rem;
  font-weight: 700;
}

.header nav a {
  margin-left: 1.5rem;
  font-weight: 500;
  color: #bbb;
}

.header nav a:hover {
  color: #fff;
}

/* Sidebar */
.sidebar {
  width: 240px;
  background: #15152B;
  color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.sidebar .logo {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 40px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  margin-bottom: 20px;
}

.sidebar a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #bbb;
  font-size: 14px;
  text-decoration: none;
}

.sidebar a.active,
.sidebar a:hover {
  color: #fff;
  background-color: #2C2C3E;
  border-radius: 8px;
  padding: 10px;
}

/* Glow effect */
.glow {
  box-shadow: 0 0 8px rgba(252, 39, 131, 0.3);
}

/* Grid layout for project cards */
.projects-main {
  flex: 1 1;
  padding: 40px;
  background: #0F0F1B;
  color: #fff;
  overflow-y: auto;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 24px;
  margin-top: 20px;
}

.project-card {
  background: #1C1C2E;
  border-radius: 12px;
  padding: 20px;
  text-decoration: none;
  color: #fff;
  box-shadow: 0 0 8px rgba(252, 39, 131, 0.05);
  transition: all 0.2s ease;
}

.project-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 12px rgba(252, 39, 131, 0.15);
}

/* Card content */
.card-header {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.card-sub {
  font-size: 14px;
  margin: 8px 0;
  color: #bbb;
}

.card-date {
  font-size: 12px;
  color: #888;
}

/* Search + dropdowns */
.search-input {
  background: #2A2A40;
  color: #fff;
  border: 1px solid #444;
  padding: 10px 14px;
  border-radius: 8px;
  width: 100%;
}

.dropdown {
  background: #2A2A40;
  color: white;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 10px;
}

/* Utility */
.text-muted {
  color: #888;
}

.bg-muted {
  background-color: #2A2A40;
}

.text-highlight {
  color: #FC2783;
}

.bg-highlight {
  background-color: #FC2783;
}

.fade-in-up {
  animation: fadeInUp 0.6s ease forwards;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,2CAA2C;AAC7C;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background-color: #0F0F1B;\n  color: #E4E4E7;\n  line-height: 1.6;\n}\n\n/* Headings */\nh1, h2, h3 {\n  font-weight: 700;\n  color: #ffffff;\n}\n\n/* Links */\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n/* Buttons */\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 8px;\n}\n\nbutton.primary {\n  background-color: #FC2783;\n  color: white;\n  padding: 10px 16px;\n  font-weight: 600;\n  border: none;\n}\n\nbutton.primary:hover {\n  background-color: #ff4598;\n  box-shadow: 0 0 6px rgba(252, 39, 131, 0.5);\n}\n\n/* Forms */\ninput, textarea, select {\n  font-family: inherit;\n  font-size: 1rem;\n  background-color: #2A2A40;\n  color: #fff;\n  border: 1px solid #444;\n  border-radius: 8px;\n  padding: 10px;\n}\n\ninput::placeholder {\n  color: #888;\n}\n\n/* Header */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background: #1C1C2E;\n  color: #fff;\n  border-bottom: 1px solid #2A2A40;\n}\n\n.header .logo {\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.header nav a {\n  margin-left: 1.5rem;\n  font-weight: 500;\n  color: #bbb;\n}\n\n.header nav a:hover {\n  color: #fff;\n}\n\n/* Sidebar */\n.sidebar {\n  width: 240px;\n  background: #15152B;\n  color: #fff;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar .logo {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 40px;\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n}\n\n.sidebar li {\n  margin-bottom: 20px;\n}\n\n.sidebar a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #bbb;\n  font-size: 14px;\n  text-decoration: none;\n}\n\n.sidebar a.active,\n.sidebar a:hover {\n  color: #fff;\n  background-color: #2C2C3E;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n/* Glow effect */\n.glow {\n  box-shadow: 0 0 8px rgba(252, 39, 131, 0.3);\n}\n\n/* Grid layout for project cards */\n.projects-main {\n  flex: 1;\n  padding: 40px;\n  background: #0F0F1B;\n  color: #fff;\n  overflow-y: auto;\n}\n\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 24px;\n  margin-top: 20px;\n}\n\n.project-card {\n  background: #1C1C2E;\n  border-radius: 12px;\n  padding: 20px;\n  text-decoration: none;\n  color: #fff;\n  box-shadow: 0 0 8px rgba(252, 39, 131, 0.05);\n  transition: all 0.2s ease;\n}\n\n.project-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 12px rgba(252, 39, 131, 0.15);\n}\n\n/* Card content */\n.card-header {\n  font-size: 18px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.card-sub {\n  font-size: 14px;\n  margin: 8px 0;\n  color: #bbb;\n}\n\n.card-date {\n  font-size: 12px;\n  color: #888;\n}\n\n/* Search + dropdowns */\n.search-input {\n  background: #2A2A40;\n  color: #fff;\n  border: 1px solid #444;\n  padding: 10px 14px;\n  border-radius: 8px;\n  width: 100%;\n}\n\n.dropdown {\n  background: #2A2A40;\n  color: white;\n  border: 1px solid #444;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n/* Utility */\n.text-muted {\n  color: #888;\n}\n\n.bg-muted {\n  background-color: #2A2A40;\n}\n\n.text-highlight {\n  color: #FC2783;\n}\n\n.bg-highlight {\n  background-color: #FC2783;\n}\n\n.fade-in-up {\n  animation: fadeInUp 0.6s ease forwards;\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
